import { Box, Grid, Typography } from '@mui/material'
import React from 'react'

export default function NoSessionsAvailable({ text,
  subText,
  maxWidth,
  buttonName,
  topImage,
  redirectionLink,
  buttonIcon,
  showTopImage = true,
  imageSize}) {
  return (
      <Box
      sx={{
        maxWidth: maxWidth ? maxWidth : 800,
        mx: "auto",
p: 0, 
        // p: 8,
       px:2,
        textAlign: "center",
      
 
          boxShadow: "none",      // Remove shadow
     
      }}
    >
      <Grid container spacing={1}>
        {showTopImage && (
          <Grid item xs={12}>
            <Box
              sx={{
                width: imageSize ? imageSize : 180,
                height:imageSize ? imageSize : 180,
                mx: "auto",
              }}
            >
              {topImage}
            </Box>
          </Grid>
        )}

        {/* Title */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="20px"
            color="#000000"
            sx={{
              fontWeight: 600,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
            
              lineHeight: "1.4",
            }}
          >
            {text}
          </Typography>
        </Grid>

        {/* Subtitle */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="13px"
            color="#444444"
            sx={{
              fontWeight: 600,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: 1.5,
            }}
          >
            {subText}
          </Typography>
        </Grid>

    
      </Grid>
    </Box>
  )
}
